<script setup lang="ts">
import { useToasts } from './toasts';

const toasts = useToasts();
</script>

<template>
  <div class="ddt-toasts" aria-live="polite">
    <div
      v-for="toast in toasts.items.value"
      :key="toast.id"
      class="ddt-toast"
      :class="`ddt-toast--${toast.tone}`"
      :role="toast.tone === 'error' ? 'alert' : 'status'"
      @click="toasts.dismiss(toast.id)"
    >
      {{ toast.message }}
    </div>
  </div>
</template>
